var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCal2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/cal2"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.527,
    d: "M8 2.182v2.944m8-2.944v2.944m4.59 3.766H3.09m-.075 4.354h17.92M3.088 17.532h17.824m-5.907 4.286V8.892M9.01 21.818V8.892M16 3.654c3.33.177 5 1.423 5 6.035v6.065c0 4.043-1 6.064-6 6.064H9c-5 0-6-2.021-6-6.064V9.689C3 5.077 4.67 3.84 8 3.654h8Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCal2);
export default __webpack_public_path__ + "static/media/cal2.344e0d1b33b56cabd28605219b9c923c.svg";
export { ForwardRef as ReactComponent };